var $ = jQuery.noConflict();


$(function(){

 
   
    function sgFixedFilter() {
        if (window.innerWidth <= 1024) {
            if ($('body').hasClass('filter-fixed-scrolling')) {
                $('body').removeClass('filter-fixed-scrolling');
                $('#main-collection-filters').css({'padding-top': '', 'min-height': ''});
            }
            $(window).off('scroll.sgFixedFilter');
            return;
        }

        var topFDPHeader = true;
        var topFDPHeader2 = true;
    
            var $filterElement = $('collection-filters-form.facets.facets-horizontal.filter-display-show-more');
            var $sidebar = $('#halo-sidebar');
            var $mainCollectionFilters = $('#main-collection-filters');
            
            if ($filterElement.length) {
                var wasFixed = $('body').hasClass('filter-fixed-scrolling');
                
                // If currently fixed, temporarily un-fix to get accurate position
                // Also reset min-height to ensure accurate measurement on resize
                if ($mainCollectionFilters.length) $mainCollectionFilters.css('min-height', '');

                if (wasFixed) {
                    $('body').removeClass('filter-fixed-scrolling');
                    if ($mainCollectionFilters.length) $mainCollectionFilters.css('padding-top', '');
                }
                
                // Now we can get the true document position
                window.sgFilterTop = $filterElement.offset().top;
                var mainCollectionFiltersHeight = $mainCollectionFilters.length ? $mainCollectionFilters.outerHeight(true) : 0;
                
                // Re-apply fixed state if it was fixed
                if (wasFixed) {
                    $('body').addClass('filter-fixed-scrolling');
                    if ($mainCollectionFilters.length) {
                        $mainCollectionFilters.css('padding-top', mainCollectionFiltersHeight + 'px');
                    }
                }

                // Always update min-height to reflect current height
                if ($mainCollectionFilters.length) {
                    $mainCollectionFilters.css('min-height', mainCollectionFiltersHeight + 'px');
                }
                
                var filterTop = window.sgFilterTop;
                var sidebarHeight = $sidebar.length ? $sidebar.outerHeight() : 0;

                // Check if body has b2b-custom and hide-b2b-nav classes
                const isB2bCustom = document.body.classList.contains('b2b-custom');
                const isHideB2bNav = document.body.classList.contains('hide-b2b-nav');
                const useB2bOffsets = isB2bCustom && isHideB2bNav;

                var offsetFilterHorizontal = (typeof topFDPHeader !== 'undefined' && topFDPHeader === false) ? 0 : (useB2bOffsets ? 87 : 111);

                if (topFDPHeader2) {
                    offsetFilterHorizontal += 10;
                }
                
                // Store calculated values for the scroll handler to use
                window.sgFilterData = {
                    filterTop: filterTop,
                    sidebarHeight: sidebarHeight,
                    offsetFilterHorizontal: offsetFilterHorizontal,
                    $filterElement: $filterElement,
                    $mainCollectionFilters: $mainCollectionFilters,
                    mainCollectionFiltersHeight: mainCollectionFiltersHeight
                };
                
                // Remove previous scroll handler and add new one with updated values
                $(window).off('scroll.sgFixedFilter').on('scroll.sgFixedFilter', function() {
                    var scrollTop = $(window).scrollTop();
                    var data = window.sgFilterData;

                    // Check if scroll reached the element (top + offset)
                    var threshold = data.filterTop - data.offsetFilterHorizontal;

                    if (scrollTop >= threshold) {
                        if (!$('body').hasClass('filter-fixed-scrolling')) {
                            console.log('Adding fixed class. scrollTop:', scrollTop, 'Threshold:', threshold, 'filterTop:', data.filterTop, 'useb2boffset', 87);
                            // Calculate height before applying fixed class
                            var currentHeight = data.$mainCollectionFilters.length ? data.$mainCollectionFilters.outerHeight(true) : 0;

                            $('body').addClass('filter-fixed-scrolling');
                            if (data.$mainCollectionFilters.length) {
                                data.$mainCollectionFilters.css('padding-top', currentHeight + 'px');
                                data.$mainCollectionFilters.css('min-height', currentHeight + 'px');
                            }
                        }
                    } else if (scrollTop < (threshold - 5)) { // 5px buffer to prevent flickering
                        if ($('body').hasClass('filter-fixed-scrolling')) {
                            console.log('Removing fixed class. scrollTop:', scrollTop, 'Threshold (Remove):', (threshold - 5), 'filterTop:', data.filterTop);
                            $('body').removeClass('filter-fixed-scrolling');
                            if (data.$mainCollectionFilters.length) data.$mainCollectionFilters.css('padding-top', '');
                            // Keep min-height
                        }
                    }
                });

                // Mutation Observer to handle height changes
                if (window.sgFilterObserver) {
                    window.sgFilterObserver.disconnect();
                }
                
                if ($mainCollectionFilters.length) {
                    window.sgFilterObserver = new MutationObserver(function() {
                        var wasFixed = $('body').hasClass('filter-fixed-scrolling');
                        
                        // Temporarily unfix to measure
                        if (wasFixed) {
                            $('body').removeClass('filter-fixed-scrolling');
                            $mainCollectionFilters.css('padding-top', '');
                        }
                        
                        var newHeight = $mainCollectionFilters.outerHeight(true);
                        var newTop = $filterElement.offset().top;
                        
                        // Re-apply fixed state
                        if (wasFixed) {
                            $('body').addClass('filter-fixed-scrolling');
                            $mainCollectionFilters.css('padding-top', newHeight + 'px');
                        }
                        
                        // Update stored data
                        if (window.sgFilterData) {
                            window.sgFilterData.mainCollectionFiltersHeight = newHeight;
                            window.sgFilterData.filterTop = newTop;
                        }
                    });
                    
                    window.sgFilterObserver.observe($mainCollectionFilters[0], {
                        childList: true,
                        subtree: true
                    });
                }
                
                // Note: No internal resize handler needed - resizeend() calls sgFixedFilter() on resize
            }
    }
    sgFixedFilter();

    function sgFixedFilterMobile() {
        if (window.innerWidth > 1024) {
            if ($('body').hasClass('filter-mobile-fixed-scrolling')) {
                $('body').removeClass('filter-mobile-fixed-scrolling');
            }
            $(window).off('scroll.sgFixedFilterMobile');
            return;
        }

        if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
            var $filterElement = $('collection-filters-form.facets.facets-horizontal.filter-display-show-more');
            
            if ($('body').hasClass('template-collection')) {
                var $toolbarElement = $('#CollectionProductGrid toolbar-item.toolbar');
            } else if ($('body').hasClass('template-search')) {
                var $toolbarElement = $('#CollectionProductGrid .toolbar-wrapper.toolbar-mobile');

                console.log("item lenght" + $toolbarElement.length)
            }

            if ($filterElement.length && $toolbarElement.length) {
                var wasFixed = $('body').hasClass('filter-mobile-fixed-scrolling');
                
                // If currently fixed, temporarily un-fix to get accurate position
                if (wasFixed) {
                    $('body').removeClass('filter-mobile-fixed-scrolling');
                }
                
                // Now we can get the true document position
                // Check if body has b2b-custom class and adjust offset accordingly
                let b2bOffset;
                if (document.body.classList.contains('b2b-custom')) {
                    b2bOffset = window.innerWidth < 501 ? 92 : 97;
                } else {
                    b2bOffset = 85;
                }
                window.sgFilterTopMobile = $('#CollectionProductGrid').offset().top - b2bOffset;
                
                // Re-apply fixed state if it was fixed
                if (wasFixed) {
                    $('body').addClass('filter-mobile-fixed-scrolling');
                }
                
                var filterTop = window.sgFilterTopMobile;
                
                // Store calculated value for the scroll handler to use
                window.sgFilterDataMobile = {
                    filterTop: filterTop
                };

                // Remove previous scroll handler and add new one with updated values
                $(window).off('scroll.sgFixedFilterMobile').on('scroll.sgFixedFilterMobile', function() {
                    var scrollTop = $(window).scrollTop();
                    var data = window.sgFilterDataMobile;
                    
                    if (scrollTop >= data.filterTop) {
                        if (!$('body').hasClass('filter-mobile-fixed-scrolling')) {
                            $('body').addClass('filter-mobile-fixed-scrolling');
                        }
                    } else if (scrollTop < (data.filterTop - 7)) { // 5px buffer to prevent flickering
                        if ($('body').hasClass('filter-mobile-fixed-scrolling')) {
                            $('body').removeClass('filter-mobile-fixed-scrolling');
                        }
                    }
                });
                
                // Note: No internal resize handler needed - resizeend() calls sgFixedFilterMobile() on resize
            }
        }
    }
    sgFixedFilterMobile();
 

    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {

	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;

            sgFixedFilter();

            sgFixedFilterMobile();


		}

	} // resizeend()
    

}) // document ready
